import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOG_OUT,
  GET_UNLEASHDETAILS_REQUEST,
  GET_UNLEASHDETAILS_SUCCESS,
  GET_UNLEASHDETAILS_FAILURE
} from '../constants/actionTypes';
import { userService } from '../api/loginServices';

export const userActions = {
  login,
  clear,
  fetchUnleashDetails
};

function login(username, password) {
  return (dispatch) => {
    dispatch(request());
    userService
      .login(username, password)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data?.message_digest) {
          sessionStorage.clear();
          const newUserData = { ...data };
          newUserData.username = username;
          dispatch(success(newUserData));
          return Promise.resolve();
        } else if (data.message) {
          dispatch(failure(data.message));
          return Promise.resolve();
        }
        return dispatch(failure('Unknown error while loggin in'));
      })
      .catch((err) => dispatch(failure(err)));
  };

  function request() {
    return { type: LOGIN_REQUEST };
  }
  function success(data) {
    return { type: LOGIN_SUCCESS, payload: { userDetails: data } };
  }
  function failure(message) {
    return { type: LOGIN_FAILURE, payload: { message } };
  }
}

function clear() {
  return (dispatch) => {
    dispatch(logout());
  };

  function logout() {
    return { type: LOG_OUT };
  }
}

let flags1 = 
  {
    "toggles": [
      {
        "name": "tfch.checkout.showNewDesigns",
        "enabled": true,
        "variant": {
          "name": "disabled",
          "enabled": false
        },
        "impressionData": false
      },
      {
        "name": "tfedam.documentmanager.newUI",
        "enabled": true,
        "variant": {
          "name": "disabled",
          "enabled": false
        },
        "impressionData": false
      }
    ]
  };

function fetchUnleashDetails(username) {
  return async (dispatch) => {
    dispatch({ type: GET_UNLEASHDETAILS_REQUEST });
    try {
      const response = await userService.unleashDetails(username);
      // dispatch({ type: GET_UNLEASHDETAILS_SUCCESS, payload: { flags: flags?.toggles.find(flag => flag.name === 'tfedam.documentmanager.newUI') || ''} });

      if (response.ok) {
        const flags = await response.json();
        if(Array.isArray(flags.toggles) && flags.toggles.length > 0) {
          dispatch({ type: GET_UNLEASHDETAILS_SUCCESS, payload: { flags: flags?.toggles.find(flag => flag.name === 'tfedam.documentmanager.newUI') || ''} });
        }
        else {
          dispatch({ type: GET_UNLEASHDETAILS_FAILURE, payload: { message: 'Error fetching flags' } });
          console.log('Error fetching flags',flags);
        }
      } else {
        dispatch({ type: GET_UNLEASHDETAILS_FAILURE, payload: { message: 'Error fetching flags' } });
        console.log('Error fetching flags');
      }
    }
    catch (error) {
      dispatch({ type: GET_UNLEASHDETAILS_FAILURE, payload: { message: 'Error fetching flags' }});
      console.log('Error fetching flags',error);
    }
      
  };
}